import { Tag } from '@spotify-internal/encore-web';

import { getLabelValue } from '../../utils/format-label';

import styles from './DemoTag.module.css';

export type DemoTagProps = {
  labels: Array<{ key: string; value?: string | null }>;
};

const DEMO_DATA_LABEL_KEY = 'demo_data';

const isDemoData = (labels: DemoTagProps['labels']) =>
  getLabelValue(labels, DEMO_DATA_LABEL_KEY) === 'true';

export const DemoTag = ({ labels }: DemoTagProps) =>
  isDemoData(labels) ? <Tag className={styles.tag}>Demo data</Tag> : null;
